import React, { useContext, useEffect, useState} from 'react'
// import React, { useContext, useState } from 'react'
import UserContext from '../../frontendTestContext/UserContext'
import { CgDanger } from 'react-icons/cg'
import OopsX from '../oops/OopsX'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
// import { FaTimes } from 'react-icons/fa'
// import { useNavigate } from 'react-router-dom'

const DeleteProduct = (props) => {
    const userContextUsed = useContext(UserContext)
    const user = userContextUsed.user
    const navigate = useNavigate()

    // const id = user.userId
    const [productInfo, setProductInfo] = useState({
        productName: "",
        productSlug: "",
        productPrice: "",
        description: "",
        category: "software",
        productThumbnailFile: "",
        productGalleryFile: "",
        productOwnerId: "",
        productId: ""
    })
    
    const shopData = userContextUsed.shop.products

    const id = user.userId
    
    const [notFound, setNotFound] = useState(false)
    
    const productSlug = useParams()
    const productSlugId = productSlug.productId
    useEffect(()=>{
        const productsFiltered = shopData.filter((product)=>{
            return product.productDetailsFromBackend.productUrls.productUrl === productSlugId
        })
        
        if(userContextUsed.isLoggedIn){
            if(productInfo.productName.length < 1){
                if(productsFiltered.length > 0){
                    setNotFound(false)
                    const thisProduct = productsFiltered[0]
                    const detailsFromBackend = thisProduct.productDetailsFromBackend
                    if(detailsFromBackend.productOwner.userId === id){
                        setNotFound(false)
                        setProductInfo((prev)=>{
                            return({
                                ...prev,
                                productName: detailsFromBackend.productName,
                                productSlug: detailsFromBackend.productUrls.productUrl,
                                productPrice: detailsFromBackend.productPriceInDollar,
                                description: detailsFromBackend.productHeadline,
                                category: detailsFromBackend.productCategory,
                                productThumbnailFile: detailsFromBackend.productUrls.productImgUrl,
                                productGalleryFile: detailsFromBackend.productMedia.images[0].imageUrl,
                                productId: detailsFromBackend.productId,
                            })
                        })
                    } else{
                        setNotFound(true)
                    }
                } else{
                    setNotFound(true)
                }
            }
        } else{
            setNotFound(true)
        }
    }, [shopData, productSlugId, productInfo, id, userContextUsed])

    async function handleSubmit(e){
        e.preventDefault()
        const access = localStorage.getItem("access")
        if(access){
            if(user.isSeller){
                props.handleLoader(true)
                const headers = {
                    'accept': 'application/json',
                    'Authorization': `JWT ${access}`,
                    'X-CSRFToken': 'uPI26MUqydFtbtfOjm2eLDK6GVnuigxrMaDKInwA4Yv0FypyDKfN6PKjA2BXwhwN',
                };
                try {
                    console.clear()
                    console.log(productSlugId)
                    const response = await axios.delete(`https://shoptinga.onrender.com/api/products/${productSlugId}/`, {headers});
                    console.log(response.data)
                    userContextUsed.functions.handleNotification("Product deleted successfully", "success")
                    navigate("/dashboard")
                } catch (error) {
                    console.error(error);
                    props.handleLoader(false)
                    userContextUsed.functions.handleNotification("Failed to delete product", "error")
                }
                // setTimeout(()=>{
                //     props.handleLoader(false)
                //     alert("Hasn't been Integrated")
                // }, 1000)
            }
        }
    }

  return (
    <>
        {notFound === false ? <div className='signup new-product-big'>
            <div className="content">
                <h2 style={{marginBottom: "20px"}}>Delete Product</h2>
                <div className="card">
                    <form onSubmit={handleSubmit}>
                        <div className="info">
                            Confirm that you want to delete <span style={{
                                fontSize: "18px",
                                fontWeight: "700",
                                margin: "0 0",
                                marginRight: "5px"
                            }}>{productInfo.productName.length > 0 ? productInfo.productName : "...." }</span> and all it's associated data. <br /> This action can not be reversed
                        </div>
                        <button className='reset__btn'>
                            Delete Permanently <CgDanger style={{marginLeft: "10px"}}/>
                        </button>
                    </form>
                </div>
            </div>
        </div> : <OopsX />}
    </>
  )
}

export default DeleteProduct